<template>
  <v-container fluid>
    <v-layout align-center justify-center>
      <v-card style="width: 700px">

        <v-flex>
          <div>
            <loading-component :value="loading" />
            <div class="conversation-messages">
              <div class="header">
                <p>
                  {{ $t("dispatching.bookingChat.header", { id: $route.params.id }) }}
                </p>
              </div>
              <div class="messages-container" ref="messagesContainer">
                <div class="messages">
                  <div v-if="messages.length == 0">{{ noMessages ? $t("dispatching.bookingChat.noMessages") : err_msg }}</div>

                  <div :class="{
                    'message-left': m.author.startsWith('MC_taxi_passenger'),
                    'message-right': !m.author.startsWith('MC_taxi_passenger')
                  }" v-for="(m) in messages">
                    <div class="bubble">
                      <div class="author" :style="`color:rgb(110 111 124);`">
                        {{ m.author }}
                      </div>
                      <div class="message-content" v-html="formatBody(m.body)">


                      </div>
                      <div class="message-info">
                        <span style="float: left">{{
                          moment(m.date_updated).format("YYYY-MM-DD HH:mm")
                        }}</span>

                      </div>
                    </div>
                  </div>

                </div>

              </div>

            </div>
          </div>
        </v-flex>
        <!--</v-responsive>-->
      </v-card>
    </v-layout>
  </v-container>

</template>

<script>
import LoadingComponent from "@/components/LoadingComponent";

export default {
  name: "BookingChat",
  title() {
    return this.$t("dispatching.bookingChat.title");
  },
  components: {
    LoadingComponent
  },

  data() {
    return {
      loading: true,
      err_msg: "",
      noMessages: false,
      messages: []
    };
  },
  mounted() {
    this.axios.get(this.api.ACTIONS.BOOKING_CHAT(this.$route.params.id)).then(({ data }) => {
      this.messages = data.data;
      if (this.messages.length == 0)
        this.noMessages = true
    }).catch((err) => {
      if (err.response.data.message)
        this.err_msg = err.response.data.message;
    }).finally(
      () => this.loading = false
    );
  },
  methods: {
    colorCoding(string) {
      const color = () => Math.floor(Math.random() * (160 - 80 + 1) + 40);
      return `rgb(${color()},${color()},${color()})`;
    },
    formatBody(text) {
      return text.replace(/\n/g, '<br/>');
    },
    getFormattedDate(string) {
      const currentDate = new Date().toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      });
      const month = this.monthName(string.getMonth());
      const day = this.addLeadingZero(string.getDate());

      if (`${month} ${string.getDate()}` == currentDate) {
        return 'today';
      } else if (this.isYesterday(string.getMonth(), day)) {
        return 'yesterday';
      } else {
        return `${month} ${day}`;
      }
    },
    isYesterday(month, day) {
      const currentDate = new Date();
      const targetDate = new Date(currentDate.getFullYear(), month, day);

      // Calculate the date one day ago
      currentDate.setDate(currentDate.getDate() - 1);

      return currentDate.toDateString() === targetDate.toDateString();
    },
    monthName(number) {
      const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul",
        "Aug", "Sep", "Oct", "Nov", "Dec"
      ];

      return monthNames[number];
    },
    addLeadingZero(value) {
      return value < 10 ? `0${value}` : value;
    }
  },

};
</script>


<style lang="scss" scoped>
.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
            supported by Chrome, Edge, Opera and Firefox */
}

.conversation-messages {

  height: 100%;

  .header {
    width: 100%;
    padding: 16px 30px;
    float: left;
    font-size: 16px;
    font-weight: 600;
    background: #f0f2f4;
    flex-grow: 0;
    flex-shrink: 0;
    height: 72px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    p {
      margin: 0;
    }
  }

  .messages-container {
    width: 100%;
    max-height: 70vh;
    float: left;
    flex-grow: 1;
    flex-shrink: 1;
    padding: 12px 26px;
    overflow-y: overlay;
    position: relative;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background-color: #ededed;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #788e98;
    }

    .messages {
      width: 100%;
      max-width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      gap: 24px;
      float: left;
      position: relative;

      .loadingLabel {
        margin: auto;
      }

      .message-left {
        width: 100%;
        max-width: 100%;
        float: left;
        display: flex;
        height: auto;
        align-items: flex-start;
        gap: 5px;
        flex-direction: column;


        .bubble {

          padding: 11px;
          padding-top: 6px;
          padding-bottom: 4px;
          float: left;
          background: #dfe8ec;
          border: 1px solid #d6e0e5;
          border-radius: 12px;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          max-width: 45%;

          .author {
            font-size: 12px;
            margin-bottom: 4px;
          }

          &:first-child {
            border-top-left-radius: 12px;
          }

          &:last-child {
            border-bottom-left-radius: 12px;
          }

          .message-content {
            width: 100%;
            font-size: 16px;
            float: left;
            color: #222629;
          }

          .message-info {
            width: 100%;
            font-size: 10px;
            float: left;
            margin-top: 7px;

            .seenSpan {
              display: none;
            }

            .seenSpanCC {
              display: inline;
            }
          }
        }

      }

      .message-right {
        width: 100%;
        max-width: 100%;
        float: left;
        display: flex;
        height: auto;
        align-items: flex-end;
        gap: 5px;
        flex-direction: column;


        .bubble {

          padding: 11px;
          padding-top: 6px;
          padding-bottom: 4px;
          float: left;
          background: #dfe8ec;
          border: 1px solid #d6e0e5;
          border-radius: 12px;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          max-width: 45%;

          .author {
            font-size: 12px;
            margin-bottom: 4px;
          }

          &:first-child {
            border-top-left-radius: 12px;
          }

          &:last-child {
            border-bottom-left-radius: 12px;
          }

          .message-content {
            width: 100%;
            font-size: 16px;
            float: left;
            color: #222629;
          }

          .message-info {
            width: 100%;
            font-size: 10px;
            float: left;
            margin-top: 7px;

            .seenSpan {
              display: none;
            }

            .seenSpanCC {
              display: inline;
            }
          }
        }

      }
    }
  }


}
</style>
